module.exports = __webpack_public_path__ + "img/fastcharger-disabled.ffd46a74.svg";